import React, { useState } from "react";
import "./Slider.css";
import BtnSlider from "./BtnSlider";

export default function Slider({ data }) {
  const [slideIndex, setSlideIndex] = useState(1);

  const nextSlide = () => {
    if (slideIndex !== data.images.length) {
      setSlideIndex(slideIndex + 1);
    } else if (slideIndex === data.images.length) {
      setSlideIndex(1);
    }
  };

  const prevSlide = () => {
    if (slideIndex !== 1) {
      setSlideIndex(slideIndex - 1);
    } else if (slideIndex === 1) {
      setSlideIndex(data.images.length);
    }
  };

  const moveDot = (index) => {
    setSlideIndex(index);
  };

  return (
    <div className="container-slider">
      {data.images.map((obj, index) => {
        return (
          <div className="portfolio-item">
            <div
              key={data.name}
              className={
                slideIndex === index + 1 ? "slide active-anim" : "slide"
              }
            >
              <img
                src={process.env.PUBLIC_URL + "/" + obj}
                className="lazyload item-img"
              />
              <div className="overlay">
                <div className="portfolio-item-meta">
                  <h5>ssaasdads</h5>
                  <p>s</p>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      <BtnSlider moveSlide={nextSlide} direction={"next"} />
      <BtnSlider moveSlide={prevSlide} direction={"prev"} />

      <div className="container-dots">
        {Array.from({ length: data.images.length }).map((item, index) => (
          <div
            onClick={() => moveDot(index + 1)}
            className={slideIndex === index + 1 ? "dot active" : "dot"}
          ></div>
        ))}
      </div>
    </div>
  );
}
